"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = require("styled-components");
var styled_system_1 = require("styled-system");
var asRendition_1 = require("../asRendition");
var utils_1 = require("../utils");
var Txt_1 = require("./Txt");
var Heading = styled_components_1.default.h3(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", ";\n\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", ";\n\n  ", "\n  ", "\n"])), Txt_1.align, styled_system_1.color, styled_system_1.fontSize, styled_system_1.space, utils_1.monospace, Txt_1.caps, Txt_1.bold);
Heading.displayName = 'Heading';
Heading.defaultProps = {
    fontSize: 4,
    m: 0,
};
var Base = asRendition_1.default(Heading);
Base.h1 = asRendition_1.default(Heading.withComponent('h1'));
Base.h1.defaultProps = {
    fontSize: 6,
    m: 0,
};
Base.h2 = asRendition_1.default(Heading.withComponent('h2'));
Base.h2.defaultProps = {
    fontSize: 5,
    m: 0,
};
Base.h3 = asRendition_1.default(Heading.withComponent('h3'));
Base.h3.defaultProps = {
    fontSize: 4,
    m: 0,
};
Base.h4 = asRendition_1.default(Heading.withComponent('h4'));
Base.h4.defaultProps = {
    fontSize: 3,
    m: 0,
};
Base.h5 = asRendition_1.default(Heading.withComponent('h5'));
Base.h5.defaultProps = {
    fontSize: 2,
    m: 0,
};
Base.h6 = asRendition_1.default(Heading.withComponent('h6'));
Base.h6.defaultProps = {
    fontSize: 1,
    m: 0,
};
exports.default = Base;
var templateObject_1;
